export const shouldLoad = () => document.querySelector('[data-controller~=content-block--booklet]') !== undefined;
